import { MinimalVersion, IMicrofront } from '../../interfaces/MFE/IMicrofront';
import { Auragin } from 'auragin'
import ACCOUNT_MODULE from '../../../../config/modules/accounts.json'
import INITIAL_MODULES from '../../../../config/modules/initial-modules.json'
import blobToBase64 from '../blobToBase64'
import logError from '../../consts/log-error'
import readModulesFromDevice from './read-modules'
import { filesystem } from '../init'
import { IDiscoveryResponse } from '../../interfaces/MFE/IDiscoveryAPI';

export async function validateDownloadedModules( microfrontendsResponse: IDiscoveryResponse ): Promise<any>{

  const modules = await readModulesFromDevice()
  return await Promise.all(
    microfrontendsResponse.microFrontends
      .filter( module => INITIAL_MODULES.core.indexOf( module.mfe_id ) > -1 || INITIAL_MODULES.baseComponents.indexOf( module.mfe_id ) > -1 || INITIAL_MODULES.features.indexOf( module.mfe_id ) > -1 )
      .map(( module ) => checkInitialModule( module, modules))
  )

}

async function checkInitialModule (module: IMicrofront, modules: MinimalVersion[]): Promise<void> {
    const found = modules.find(rv => rv.mfe_id === module.mfe_id)
    if (found === undefined && filesystem !== undefined) {
      const path = filesystem.getPath('modules', { filename: `${module.mfe_id}.zip`, mfe_id: module.mfe_id, mfe_version: module.version })
      return await fetch(`/assets/modules/${module.mfe_id}.zip`)
        .then(async res => await res.blob())
        .then(async blob => await blobToBase64(blob))
        .then(async base64 => await Auragin.unZipLocal({ fullPath: path, base64 }))
        .catch(logError)
    }
  }